// extracted by mini-css-extract-plugin
export var cardSelected = "_gt-2";
export var image = "_gt-1";
export var table = "_gt-0";